/**
 * NIGHTBOUND - item icon.
 *
 * Probes `public/assets/items/<itemKey>.*` and falls back to the item's glyph.
 * Dropping an icon file into the items folder is all that is needed.
 */

import { useMemo } from 'react'
import { itemIconCandidates } from '../../shared/assets/manifest'
import { useFirstAvailableAsset } from '../hooks'
import { cx } from './ui'

const SIZES = {
  sm: 'h-6 w-6 text-lg',
  md: 'h-9 w-9 text-2xl',
  lg: 'h-14 w-14 text-4xl',
} as const

export function ItemIcon({
  itemKey,
  glyph,
  size = 'md',
  className,
}: {
  itemKey: string
  glyph: string
  size?: keyof typeof SIZES
  className?: string
}) {
  const candidates = useMemo(() => itemIconCandidates(itemKey), [itemKey])
  const { src } = useFirstAvailableAsset(candidates)

  if (src) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden
        draggable={false}
        className={cx('select-none object-contain', SIZES[size], className)}
      />
    )
  }

  return (
    <span aria-hidden className={cx('flex items-center justify-center', SIZES[size], className)}>
      {glyph}
    </span>
  )
}
